import { DropdownOption } from "@/models/DropdownOption";

export const refererOptions = require("./refererOptions.json") as DropdownOption[];